import { render, staticRenderFns } from "./project.list.vue?vue&type=template&id=24973c23&scoped=true&"
import script from "./project.list.vue?vue&type=script&lang=js&"
export * from "./project.list.vue?vue&type=script&lang=js&"
import style0 from "./project.list.vue?vue&type=style&index=0&id=24973c23&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24973c23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\public\\Isaura\\id.es6.vn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24973c23')) {
      api.createRecord('24973c23', component.options)
    } else {
      api.reload('24973c23', component.options)
    }
    module.hot.accept("./project.list.vue?vue&type=template&id=24973c23&scoped=true&", function () {
      api.rerender('24973c23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/project.list.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/project/project.list.vue
// module id = 708
// module chunks = 2